var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 16C7.25 15.5858 7.58579 15.25 8 15.25H23.75C24.1642 15.25 24.5 15.5858 24.5 16C24.5 16.4142 24.1642 16.75 23.75 16.75H8C7.58579 16.75 7.25 16.4142 7.25 16Z",
    fill: "#9DA1B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 11.5C7.25 11.0858 7.58579 10.75 8 10.75H23.75C24.1642 10.75 24.5 11.0858 24.5 11.5C24.5 11.9142 24.1642 12.25 23.75 12.25H8C7.58579 12.25 7.25 11.9142 7.25 11.5Z",
    fill: "#9DA1B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.25 20.5C7.25 20.0858 7.58579 19.75 8 19.75H23.75C24.1642 19.75 24.5 20.0858 24.5 20.5C24.5 20.9142 24.1642 21.25 23.75 21.25H8C7.58579 21.25 7.25 20.9142 7.25 20.5Z",
    fill: "#9DA1B5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16C17 16.8284 16.3284 17.5 15.5 17.5C14.6716 17.5 14 16.8284 14 16C14 15.1716 14.6716 14.5 15.5 14.5C16.3284 14.5 17 15.1716 17 16Z",
    fill: "#9DA1B5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16C18 17.3807 16.8807 18.5 15.5 18.5C14.1193 18.5 13 17.3807 13 16C13 14.6193 14.1193 13.5 15.5 13.5C16.8807 13.5 18 14.6193 18 16ZM15.5 17.5C16.3284 17.5 17 16.8284 17 16C17 15.1716 16.3284 14.5 15.5 14.5C14.6716 14.5 14 15.1716 14 16C14 16.8284 14.6716 17.5 15.5 17.5Z",
    fill: "#F6F8FB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 11.5C21.5 12.3284 20.8284 13 20 13C19.1716 13 18.5 12.3284 18.5 11.5C18.5 10.6716 19.1716 10 20 10C20.8284 10 21.5 10.6716 21.5 11.5Z",
    fill: "#9DA1B5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 11.5C22.5 12.8807 21.3807 14 20 14C18.6193 14 17.5 12.8807 17.5 11.5C17.5 10.1193 18.6193 9 20 9C21.3807 9 22.5 10.1193 22.5 11.5ZM20 13C20.8284 13 21.5 12.3284 21.5 11.5C21.5 10.6716 20.8284 10 20 10C19.1716 10 18.5 10.6716 18.5 11.5C18.5 12.3284 19.1716 13 20 13Z",
    fill: "#F6F8FB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.5C13.5 21.3284 12.8284 22 12 22C11.1716 22 10.5 21.3284 10.5 20.5C10.5 19.6716 11.1716 19 12 19C12.8284 19 13.5 19.6716 13.5 20.5Z",
    fill: "#9DA1B5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5 20.5C14.5 21.8807 13.3807 23 12 23C10.6193 23 9.5 21.8807 9.5 20.5C9.5 19.1193 10.6193 18 12 18C13.3807 18 14.5 19.1193 14.5 20.5ZM12 22C12.8284 22 13.5 21.3284 13.5 20.5C13.5 19.6716 12.8284 19 12 19C11.1716 19 10.5 19.6716 10.5 20.5C10.5 21.3284 11.1716 22 12 22Z",
    fill: "#F6F8FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfig);
export default __webpack_public_path__ + "static/media/config.d83c4aa1b6f4d1b21eac1dcecfe68e95.svg";
export { ForwardRef as ReactComponent };